export default {
  queueList (state, payload) {
    state.queueList = payload
  },
  setIsSocketDisconnected (state, payload) {
    state.isSocketDisconnected = payload
  },
  clearSelectedClientRequest (state) {
    state.selectedClientRequest.clear()
  },
  setIsOffline (state, payload) {
    state.isOffline = payload
  },
  // 변경사항 flag 설정
  setChangeFlag (state, payload) {
    if (payload === 'waiting') {
      state.waitingCountChange = true
    } else if (payload.includes('menu')) {
      state.menuInfoChange = true
    } else {
      state.restaurantInfoChange = true
    }
  },
  setAccessToken (state, payload) {
    localStorage.setItem('accessToken', payload)
    state.accessToken = payload
  },
  setRefreshToken (state, payload) {
    localStorage.setItem('refreshToken', payload)
    state.refreshToken = payload
  },
  setStoreIdx (state, payload) {
    localStorage.setItem('restaurantIdx', payload)
    state.restaurant.idx = payload
  },
  removeSocketInstance (state) {
    if (state.socket === null) return
    state.socket = null
  },
  setSocketInstance (state, payload) {
    if (state.socket) return
    state.socket = payload
  },
  mutationByKeyValue (state, payload) {
    payload.forEach(element => {
      state[element.key] = element.value
    })
  },
  setSelectedClientRequest (state, payload) {
    state.selectedClientRequest.set(payload.key, payload.value)
  },
  deleteSelectedClientRequest (state, payload) {
    state.selectedClientRequest.delete(payload)
  },
  clientRequestList (state, payload) {
    const newArr = payload.map((request) => {
      request.isSelected = state.selectedClientRequest.has(request.idx)
      return request
    })
    state.clientRequestList = newArr
  },
  restaurantMenuInfo (state, payload) {
    state.restaurantMenuInfo = payload
  },
  setWaitingParams (state, payload) {
    const keyArr = Object.keys(payload)
    if (keyArr.length === 0) { return }
    keyArr.forEach((key) => {
      state.waitingParams[key] = payload[key]
    })
    localStorage.setItem('waitingParams', state.waitingParams)
  },
  menuInfoChange (state, payload) {
    state.menuInfoChange = payload
  },
  restaurantInfoChange (state, payload) {
    state.restaurantInfoChange = payload
  },
  waitingCountChange (state, payload) {
    state.waitingCountChange = payload
  },
  waitingCount (state, payload) {
    state.waitingCount = payload
  },
  otpNumber (state, payload) {
    state.otpNumber = payload
  },
  timeoutObj (state, payload) {
    state.timeoutObj = payload
  },
  locale (state, payload) {
    state.locale = payload
    localStorage.setItem('baseLocale', payload)
    const body = document.body
    if (body.classList.contains('ko')) { body.classList.remove('ko') }
    if (body.classList.contains('en')) { body.classList.remove('en') }
    if (body.classList.contains('jp')) { body.classList.remove('jp') }
    if (body.classList.contains('cn_simplified')) { body.classList.remove('cn_simplified') }
    body.classList.add(state.locale)
  },
  restaurant (state, payload) {
    if (!payload) {
      return
    }
    const keys = Object.keys(payload)
    keys.forEach((key) => {
      state.restaurant[key] = payload[key]
    })
  }
}
